<template>
  <div class="route-board mt-2 mx-2" v-on:click="toggleRoute">
    <span
      class="route-label font-bold text-link"
      v-bind:class="{ 'route-open' : isOpen }">
      {{ $t('tour_route_label') }}
    </span>
    <div class="route-wrapper">
      <div v-if="!isOpen" class="route-outline p-3">
        <p class="route-outline-time">
          <span class="is-departure font-bold">{{ departure.format("HH:mm") }}</span>
          <span class="is-arrival font-bold">{{ arrival.format("HH:mm") }}</span>
          <span class="text-sm">（{{ duration + this.$t('tour_minute_label') }}）</span>
        </p>
        <ul class="route-outline-point pt-2 text-btn_secondary-lighter font-sm">
          <li v-for="(o, index) in outline" v-bind:key="index">
            <span v-if="typeof(o) === 'string'">{{ o }}</span>
            <line-icon v-else :line=o />
          </li>
        </ul>
      </div>
      <route-detail
        v-show=isOpen
        :route=route />
    </div>
  </div>
</template>

<script>
import RouteDetail from "./RouteDetail"
import LineIcon from "../atoms/LineIcon"

export default {
  components: {
    RouteDetail,
    LineIcon
  },
  props: {
    route: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    toggleRoute: function () {
      this.isOpen = !this.isOpen
    }
  },
  computed: {
    departure: function () {
      const t = this.route.points[0].departureTime
      return t
    },
    arrival: function () {
      const last = this.route.points.length - 1
      const t = this.route.points[last].arrivalTime
      return t

    },
    duration: function () {
      return this.arrival.diff(this.departure, "minutes")
    },
    outline: function () {
      const points = this.route.points.concat()
      let a = []

      // 最初は路線だけで最後はいらない
      a.push(points.shift().line)
      points.pop()

      points.map((point) => {
        a.push(point.name)
        a.push(point.line)
      })

      return a
    }
  }
}
</script>
